<template>
    <modal ref="modal" noWrapper>
          <div id="sub-wrapper">
              <div :class="subWrapperSliderClassName()">
                  <div id="onboarding">
                      <div :class='onboardingSliderClassName()'>
                          <div v-for="index in stepsNumber" :key="index" class="item">
                              <header>
                                  <img class="background" src='~@/assets/img/onboarding_background.jpg'/>
                                  <img class="img" :src="require('@/assets/img/onboarding_step' + index + '.png')"/>
                              </header>
                              <footer>
                                  <div class="title">{{ $t('modals.onboarding.step' + index + '.title') }}</div>
                                  <div class="text">{{ $t('modals.onboarding.step' + index + '.text') }}</div>
                              </footer>
                          </div>
                      </div>
                      <div class="skip" @click="onPagingClick(stepsNumber+1)">{{ $t('modals.onboarding.skip') }}</div>
                      <div class="paging">
                          <div>
                              <div v-for="index in stepsNumber" :key="index" :class="index === currentStep ? 'active': ''" @click="onPagingClick(index)"/>
                          </div>
                      </div>
                      <button v-if="currentStep > 1" class="button-2 previous" @click="onPagingClick(currentStep-1)">{{ $t('modals.onboarding.previous') }}</button>
                      <button class="next" @click="onPagingClick(currentStep+1)">{{ $t('modals.onboarding.' + (currentStep >= stepsNumber ? 'finished' : 'next')) }}</button>
                  </div>
                  <div id="orientation">
                      <div class="title">{{ $t("modals.orientation.title") }}</div>
                      <div class="subtitle">{{ $t("modals.orientation.subtitle") }}</div>
                      <div class="choice">
                          <div @click="onChoose('landscape')" :class="choiceClassName('landscape')">
                              <div class="img">
                                  <img src="~@/assets/img/mobile_landscape.svg"/>
                              </div>
                              <div class="text">
                                  {{ $t("modals.orientation.landscape") }}
                              </div>
                          </div>
                          <div @click="onChoose('story')" :class="choiceClassName('story')">
                              <img class="badge" src="~@/assets/img/new.png"/>
                              <div class="img">
                                  <img src="~@/assets/img/mobile_story.svg"/>
                              </div>
                              <div class="text">
                                  {{ $t("modals.orientation.story") }}
                              </div>

                          </div>
                      </div>
                      <div class="button">
                          <button @click="onSubmit">{{ $t("modals.orientation.button") }}</button>
                      </div>
                  </div>
              </div>
          </div>
    </modal>
</template>

<script>
import auth from '@/services/auth'
import event from '@/services/event'
import user from '@/services/user'

export default {
  data () {
    return {
      currentStep: 1,
      orientation: 'landscape',
      showOrientation: false,
      stepsNumber: 4
    }
  },
  methods: {
    show (onboarding, orientation) {
      if (!onboarding) {
        this.showOrientation = true
      }
      this.orientation = orientation
      this.$refs.modal.show()
    },
    showing () {
      return this.$refs.modal.showing()
    },
    hide () {
      this.$refs.modal.hide()
    },
    subWrapperSliderClassName () {
      return 'slider ' + (this.showOrientation ? 'slided-orientation' : 'slided-onboarding')
    },
    onboardingSliderClassName () {
      return 'slider slided-step-' + this.currentStep
    },
    onPagingClick (index) {
      // Onboarding is over
      if (index > this.stepsNumber) {
        // Update user
        user.update(true)
          .then(() => {
            // Show orientation
            this.showOrientation = true

            // Update user
            var u = auth.user
            if (!u.onboarded) {
              u.onboarded = true
              auth.user = u
            }
          })
          .catch(err => {
          // Toast
            this.$parent.$parent.$parent.$refs.toaster.error(err)
          })
        return
      }

      // Update step
      this.currentStep = index
    },
    choiceClassName (orientation) {
      return this.orientation === orientation ? 'active' : ''
    },
    onChoose (orientation) {
      this.orientation = orientation
    },
    onSubmit () {
      // Update event
      event.update(this.$route.params.event_id, null, null, this.orientation)
        .then(() => {
          // Hide modal
          this.$refs.modal.hide()
        })
        .catch(err => {
          // Toast
          this.$parent.$parent.$parent.$refs.toaster.error(err)
        })
    }
  }
}
</script>

<style scoped>

#sub-wrapper {
  background-color: #323232;
  border-radius: 1em;
  color: #ffffff;
  height: 40em;
  overflow: hidden;
  width: 52em;
}

#sub-wrapper > .slider {
  height: 100%;
  position: relative;
  transition: transform .5s ease;
  width: 200%;
}

#sub-wrapper > .slider.slided-onboarding {
  transform: translateX(0%);
  -webkit-transform: translateX(0%);
}

#sub-wrapper > .slider.slided-orientation {
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
}

#sub-wrapper > .slider > div {
  float: left;
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 50%;
}

#sub-wrapper .skip {
  cursor: pointer;
  opacity: 0.7;
  position: absolute;
  right: 2em;
  top: 2em;
}

#sub-wrapper .skip:hover {
  opacity: 1;
}

#sub-wrapper .paging {
  bottom: 2.5em;
  display: flex;
  height: 3em;
  position: absolute;
  width: 100%;
}

#sub-wrapper .paging > div {
  margin: auto;
}

#sub-wrapper .paging > div > div {
  background-color: #7c7c7c;
  border-radius: 50%;
  cursor: pointer;
  display: inline-block;
  height: 0.5em;
  margin-right: 0.5em;
  width: 0.5em;
}

#sub-wrapper .paging > div > div:last-child {
  margin-right: 0;
}

#sub-wrapper .paging > div > div.active, #sub-wrapper .paging > div > div:hover {
  background-color: #ff6e20;
}

#sub-wrapper .previous {
  left: 2.5em;
  position: absolute;
  bottom: 2.5em;
}

#sub-wrapper .next, #sub-wrapper .finished {
  right: 2.5em;
  position: absolute;
  bottom: 2.5em;
}

.button-2 {
  background-color: #7c7c7c;
}

.button-2:hover {
  background-color: #666666;
}

#sub-wrapper #onboarding .slider {
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  transition: transform .5s ease;
  width: 400%;
}

#sub-wrapper #onboarding .slider.slided-step-1 {
  transform: translateX(0%);
  -webkit-transform: translateX(0%);
}

#sub-wrapper #onboarding .slider.slided-step-2 {
  transform: translateX(-25%);
  -webkit-transform: translateX(-25%);
}

#sub-wrapper #onboarding .slider.slided-step-3 {
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
}

#sub-wrapper #onboarding .slider.slided-step-4 {
  transform: translateX(-75%);
  -webkit-transform: translateX(-75%);
}

#sub-wrapper #onboarding .item {
  display: flex;
  flex-direction: column;
  float: left;
  height: 100%;
  width: 25%;
}

#sub-wrapper #onboarding .item header {
  background-color: #141414;
  display: flex;
  height: 60%;
  position: relative;
  width: 100%;
}

#sub-wrapper #onboarding .item header .background {
  height: 100%;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 100%;
}

#sub-wrapper #onboarding .item header .img {
  height: 100%;
  margin: auto;
  position: relative;
}

#sub-wrapper #onboarding .item footer {
  padding: 2.5em 8em 0 8em;
}

#sub-wrapper #onboarding .item footer .title {
  font-size: 1.8em;
  font-weight: 600;
  margin-bottom: 0.7em;
}

#sub-wrapper #onboarding .item footer .text {
  font-size: 1.2em;
}

#sub-wrapper #orientation {
  display: flex;
  flex-direction: column;
  padding: 2.5em 4em;
}

#sub-wrapper #orientation .title {
  height: 10%;
}

#sub-wrapper #orientation .subtitle {
  height: 10%;
}

#sub-wrapper #orientation .choice {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 2em;
  height: 66%;
  width: 100%;
}

#sub-wrapper #orientation .choice > div {
  background-color: #4a4a4a;
  border: solid 1px #4a4a4a;
  border-radius: 0.3em;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 100%;
  position :relative;
  width: 100%;
}

#sub-wrapper #orientation .choice > div:hover, #sub-wrapper #orientation .choice > div.active {
  border: solid 1px #959595;
}

#sub-wrapper #orientation .choice .badge {
  height: 2em;
  position: absolute;
  right: 0.8em;
  top: 0.8em;
}

#sub-wrapper #orientation .choice .img {
  display: flex;
  height: 80%;
  width: 100%;
}

#sub-wrapper #orientation .choice .img > img {
  margin: auto auto 0 auto;
}

#sub-wrapper #orientation .choice .text {
  height: 20%;
  padding-top: 1em;
  width: 100%;
}

#sub-wrapper #orientation .button {
  display: flex;
  height: 14%;
}

#sub-wrapper #orientation .button > button {
  margin: auto auto 0 auto;
}

/*

#sub-wrapper #orientation .choice > div > div:last-child {
  display: table;
  height: 100%;
  width: 100%;
}

#sub-wrapper #orientation .choice > div > div:last-child > div {
  display: table-cell;
  vertical-align: bottom;
}

#sub-wrapper #orientation .choice > div > div:last-child > div > img {
  margin-bottom: 0.5em;
}

#sub-wrapper #orientation .choice > div > div:last-child > div > div {
  font-size: 1.3em;
}

#sub-wrapper #orientation .button {
  display: flex;
  height: 14%;
}

#sub-wrapper #orientation .button > button {
  margin: auto auto 0 auto;
}

*/

</style>
